import { Descriptions } from "antd";
import { useEffect, useState } from "react";
import { CgCloseR } from "react-icons/cg";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { getMembers } from "../../api/messages.api";
import { sendTextMessages } from "../../api/pushMessage.api";
import Button from "../../components/Button";
import ErrorResponse from "../../components/ErrorResponse";
import SimpleHeader from "../../components/layout/SimpleHeader";
import Loader from "../../components/Loader";
import SelectMemberModal from "../../components/message/write/modals/SelectMemberModal";
import useAuth from "../../hooks/useAuth";
import useAxios from "../../hooks/useAxios";
import useNotification from "../../hooks/useNotification";
import { campusHeadOffice } from "../../lib/data";
import { IGetMembers } from "../../models/messages.model";
import { RootState } from "../../store/rootReducer";

const SmsWrite = () => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const history = useHistory();
  const { auth, currentCampus } = useSelector((state: RootState) => state.auth);
  const { campusData } = useSelector((state: RootState) => state.campusData);
  const { successNotification, infoNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetMembers>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  const [outgoingNumber, setOutgoingNumber] = useState('');
  const [memberCodes, setMemberCodes] = useState<string[]>([]);
  const [content, setContent] = useState('');
  const [selectMemberVisible, setSelectMemberVisible] = useState(false);

  useEffect(() => {
    execute(getMembers());    
  }, []);

  useEffect(() => {
    if (auth && campusData) {
      let phoneNumber = '';
      if (auth.hqYn === 'Y') {
        phoneNumber = campusData.find(campus => campus.campusCode === campusHeadOffice)?.telephoneNo || '';
      } else {
        phoneNumber = campusData.find(campus => campus.campusCode === currentCampus)?.telephoneNo || '';
      }
      setOutgoingNumber(phoneNumber.replace(/-/gi, ''));
    }
  }, [auth, campusData]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(t('message.smsWrite.message1'));
      history.push('/message/sms-send');
    }
  }, [submitRes, submitIsLoading]);

  const getMemberName = (memberCode: string) => {
    const member = res?.data.find((item) => item.memberCode === memberCode);
    return member ? member.memKorName : '';
  };

  const onDeleteMember = (memberCode: string) => {
    setMemberCodes(memberCodes.filter((item) => item !== memberCode));
  };

  const onSubmit = () => {
    if (!outgoingNumber) {
      return infoNotification(t('message.smsWrite.message2'));
    }
    if (memberCodes.length === 0) {
      return infoNotification(t('message.smsWrite.message3'));
    }
    if (!content) {
      return infoNotification(t('homepage.archive.message4'));
    }
    if (content.length > 1000) {
      return infoNotification(t('message.smsWrite.message4'));
    }

    submitExecute(sendTextMessages({
      outgoingNumber,
      memberCodes,
      content,
      campusCode: auth.campus[0],
    }));
  }

  return (
    <div className="content scrollbar">
      {(isLoading || submitIsLoading) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      <SimpleHeader
        iconFile="icon-message-big.svg"
        parentMenu={t('common.menu.message')}
        currentMenu={t('message.smsSend.button1')}
      />

      <div className='comm-table__area rowType edit'>
        <Descriptions
          bordered
          column={1}
          size="middle"
          labelStyle={{ width: '200px' }}
        >
          <Descriptions.Item label={t('message.smsWrite.column1')}>
            <input
              type="number"
              className="form-control input-text"
              placeholder={t('message.smsWrite.placeholder1')}
              value={outgoingNumber}
              onChange={(e) => setOutgoingNumber(e.target.value)}
              disabled
            />
          </Descriptions.Item>
          <Descriptions.Item label={t('message.smsWrite.column2')}>
            <div className="comm-btn__area">
              <Button
                className="btn-basic black"
                onClick={() => setSelectMemberVisible(true)}
                text={t('message.smsWrite.button1')}
              />
            </div>
            {memberCodes.map((item) => (
              <>
                <span className="ml-2">{getMemberName(item)}</span>
                <span
                  className="pointer"
                  onClick={() => onDeleteMember(item)}
                >
                  <CgCloseR />
                </span>
              </>
            ))}
          </Descriptions.Item>
          <Descriptions.Item label={t('common.column.contents')}>
            <textarea
              className="w-100"
              rows={5}
              value={content}
              onChange={(e) => setContent(e.target.value)}
            />
              {t('message.smsWrite.text1')}{content.length}/1000{t('message.smsWrite.text2')}
          </Descriptions.Item>
        </Descriptions>
      </div>

      <div className="comm-bx__space">
        <div className="comm-btn__area right">
          <Button
            className="btn-basic pink-line"
            onClick={onSubmit}
            text={t('message.smsWrite.button2')}
            writeAuthYn={writeAuthYn}
          />
        </div>
      </div>

      {selectMemberVisible && (
        <SelectMemberModal
          visible={selectMemberVisible}
          setVisible={setSelectMemberVisible}
          members={res?.data}
          memberCodes={memberCodes}
          setMemberCodes={setMemberCodes}
        />
      )}
    </div>
  );
}

export default SmsWrite;
